import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useRefreshToken } from 'services/authentication-api/authentication-requests';

import { UserInfo } from 'types/user';

export const decodeToken = (authToken: string): UserInfo => {
  const decodedToken = jwtDecode(authToken);

  return decodedToken;
};

export const useAccessToken = () => {
  const [token, setToken] = useState<string>(getAuthToken());
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<UserInfo>({});
  const { mutate } = useRefreshToken();

  useEffect(() => {
    const currentTime = Date.now() / 1000;

    if (token) {
      const decodedUserInfo = decodeToken(token);
      setUserInfo(decodedUserInfo);

      if (decodedUserInfo?.exp >= currentTime) {
        setIsAuthenticated(true);
      } else {
        const refToken = getRefreshToken();

        if (refToken) {
          mutate(refToken, {
            onSuccess: res => {
              setToken(res?.accessToken);
              setUserInfo(decodeToken(res?.accessToken));
              setIsAuthenticated(true);
            },
          });
        } else {
          removeAuthToken();
          setToken(null);
          setIsAuthenticated(false);
          setUserInfo({});
        }
      }
    } else {
      removeAuthToken();
      setToken(null);
      setIsAuthenticated(false);
      setUserInfo({});
    }
  }, [token, mutate]);

  return {
    token,
    isAuthenticated,
    userInfo,
  };
};

export const updateAuthToken = (token: string) => {
  localStorage.setItem('accessToken', token);
};

export const getAuthToken = (): string => localStorage.getItem('accessToken');

export const updateRefreshToken = (token: string) => {
  localStorage.setItem('refreshToken', token);
};

export const getRefreshToken = (): string =>
  localStorage.getItem('refreshToken');

export const removeAuthToken = () => {
  localStorage.removeItem('accessToken');
};

export const removeRefreshToken = () => {
  localStorage.removeItem('refreshToken');
};

export const getNextStep = (): string => localStorage.getItem('nextStep');
export const removeNextStep = () => localStorage.removeItem('nextStep');

export const setIsFreeTrialConsumed = (freeTrialConsumed: string) => {
  localStorage.setItem('freeTrialConsumed', freeTrialConsumed);
};
export const getIsFreeTrialConsumed = (): string =>
  localStorage.getItem('freeTrialConsumed');
export const removeIsFreeTrialConsumed = () =>
  localStorage.removeItem('freeTrialConsumed');
